import React, { useState, useEffect, useCallback } from 'react';
import MapModal from '../components/MapModal';
import { createCenter, createEmployee, createClients, getAllClients, getAllEmployees, getAllCentre, updateClient, updateEmployee, updateCenter } from '../Services/masterService'
import Modal from '../AlertModal/Modal';
import Select from "react-select";
// --- Mock Data ---

const entityColumns = {
    client: ['clientName', 'clientCode', 'clientGroup', 'email', 'contactNumber', 'district', 'status'],
    employee: ['employeeName', 'employeeCode', 'userType', 'phoneNumber', 'centreName', 'email', 'status'],
    centre: ['centreName', 'centreCode', 'region', 'district', 'contactNumber', 'status'],
};



const DataList = ({ data, entityType, onEdit, onDelete }) => {
    const columns = entityColumns[entityType];
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // number of rows per page


    useEffect(() => {
        setCurrentPage(1);
    }, [data]);

    if (!data || data.length === 0) {
        return <p className="text-gray-500 p-4">No records found for {entityType}.</p>;
    }

    const entityName = entityType.charAt(0).toUpperCase() + entityType.slice(1);

    const getCellValue = (item, col) => {
        if (entityType === "employee" && col === "centreName") {
            return item.centre?.centreName || "N/A";
        }
        if (col === "status") {
            const statusText = item[col] || "INACTIVE";
            if (statusText.toUpperCase() === "ACTIVE") {
                return (
                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                        ACTIVE
                    </span>
                );
            }
            return (
                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
                    INACTIVE
                </span>
            );
        } else if (col === "isActive" && typeof item[col] === "boolean") {
            return item[col] ? (
                <span className="text-green-600 font-semibold">Active</span>
            ) : (
                <span className="text-red-600 font-semibold">Inactive</span>
            );
        }
        return item[col] || "N/A";
    };

    // Pagination logic
    const totalPages = Math.ceil(data.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = data.slice(startIndex, startIndex + itemsPerPage);

    return (
        <div className="w-full p-6 bg-white rounded-lg shadow-lg">
            <h3 className="text-xl font-semibold mb-4 text-green-800 border-b pb-2">
                {entityName} List ({data.length})
            </h3>
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-green-50">
                        <tr>
                            {columns.map((col) => (
                                <th
                                    key={col}
                                    className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider"
                                >
                                    {col.split(/(?=[A-Z])/).join(" ")}
                                </th>
                            ))}
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                                Actions
                            </th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {paginatedData.map((item) => (
                            <tr
                                key={item.id || item.clientCode || item.email}
                                className="hover:bg-gray-50"
                            >
                                {columns.map((col) => (
                                    <td
                                        key={col}
                                        className="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                                    >
                                        {getCellValue(item, col)}
                                    </td>
                                ))}
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium flex gap-1">
                                    <button
                                        className="text-white font-sm py-2 px-3 rounded text-sm theme_btn"
                                        onClick={() => onEdit(item, entityType)}
                                    >
                                        Edit
                                    </button>
                                    <button
                                        className="text-white font-sm py-2 px-3 rounded text-sm cancel_btn"
                                        onClick={() => onDelete(item)}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Pagination Controls */}
            <div className="mt-4 flex justify-center gap-2">
                <button
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                >
                    Previous
                </button>
                <span className="px-3 py-1">
                    Page {currentPage} of {totalPages}
                </span>
                <button
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(currentPage + 1)}
                >
                    Next
                </button>
            </div>
        </div>
    );
};



/**
 * COMPLETE Client Form Component (Now with Map Integration)
 */
const ClientForm = ({ editingItem, onSubmitComplete, showAlerts }) => {
    const [isMapOpen, setIsMapOpen] = useState(false);
    const [clientData, setClientData] = useState([]);
    const [employees, setEmployeeData] = useState([]);
    const [centres, setCentreData] = useState([]);

    const [formData, setFormData] = useState({
        clientName: "",
        clientCode: "",
        panelId: "",
        email: "",
        contactNumber: "",
        altNumber: "",
        clientGroup: "",
        latitude: "",
        longitude: "",
        primaryLogistic: "",
        secondaryLogistic: "",
        district: "",
        area: "",
        address: "",
        centre: "",
        password: "",
        isActive: true,
    });

    const clientGroupOptions = [
        { value: "PANEL", label: "PANEL" },
        { value: "NAPP", label: "NAPP" },
        { value: "NACP - Laboratory", label: "NACP - Laboratory" },
        { value: "NAPH", label: "NAPH" },
        { value: "NACP - Hospitals", label: "NACP - Hospitals" },
        { value: "NACC", label: "NACC" },
        { value: "PAY", label: "PAY" },
        { value: "CORPORATES", label: "CORPORATES" },
        { value: "PAY - NACP - Laboratory", label: "PAY - NACP - Laboratory" },
        { value: "PAY - NAPH", label: "PAY - NAPH" },
        { value: "PAY - NACC", label: "PAY - NACC" },
        { value: "PAY - NACP - Hospitals", label: "PAY - NACP - Hospitals" },
        { value: "NACP - Research Institutes", label: "NACP - Research Institutes" },
        { value: "NASB", label: "NASB" },
    ];


    const districtOptions = [
        { value: "Kolkata", label: "Kolkata" },
        { value: "North 24 Parganas", label: "North 24 Parganas" },
        { value: "South 24 Parganas", label: "South 24 Parganas" },
        { value: "Birbhum", label: "Birbhum" },
        { value: "Nadia", label: "Nadia" },
        { value: "Medinipur - West", label: "Medinipur - West" },
        { value: "Howrah", label: "Howrah" },
        { value: "Murshidabad", label: "Murshidabad" },
        { value: "Medinipur - East", label: "Medinipur - East" },
        { value: "Hooghly", label: "Hooghly" },
        { value: "Bardwan - East", label: "Bardwan - East" },
        { value: "Khordah", label: "Khordah" },
        { value: "Bardwan - West", label: "Bardwan - West" },
        { value: "Bankura", label: "Bankura" },
        { value: "Jhargram", label: "Jhargram" },
        { value: "Purulia", label: "Purulia" },
        { value: "Malda", label: "Malda" },
        { value: "Dinajpur - South", label: "Dinajpur - South" },
        { value: "Darjeeling", label: "Darjeeling" },
        { value: "Cooch Bihar", label: "Cooch Bihar" },
        { value: "Alipurduar", label: "Alipurduar" },
        { value: "Jalpaiguri", label: "Jalpaiguri" },
        { value: "Dinajpur - North", label: "Dinajpur - North" },
    ];

    // ✅ Open/Close Map Modal
    const handleOpenMap = () => setIsMapOpen(true);
    const handleCloseMap = () => setIsMapOpen(false);

    const fetchApiData = useCallback(async () => {
        const empResponse = await getAllEmployees();
        if (empResponse.status === 1) {
            setEmployeeData(empResponse.data.filter(user =>
                user.userType && user.userType.trim().toUpperCase() === "LOGISTIC"
            ))
            console.log('employees', employees);
        } else {
            setEmployeeData([])
        }

        const centreResponse = await getAllCentre();
        if (centreResponse.status === 1) {
            setCentreData(centreResponse.data)
        } else {
            setCentreData([])
        }
    }, []);

    useEffect(() => {
        fetchApiData();
    }, [fetchApiData]);

    // ✅ Callback from MapModal
    const handleSaveLatLong = (lat, lng) => {
        setFormData((prev) => ({ ...prev, latitude: lat, longitude: lng }));
        console.log("📍 Selected Coordinates:", lat, lng);
    };

    // Handle form input changes
    const handleChange = (e) => {
        const { id, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: type === "checkbox" ? checked : value,
        }));
    };


    const isEditMode = !!editingItem;
    useEffect(() => {
        if (editingItem) {
            setFormData({
                clientName: editingItem.clientName || "",
                clientCode: editingItem.clientCode || "",
                panelId: editingItem.panelId || "",
                email: editingItem.email || "",
                contactNumber: editingItem.contactNumber || "",
                altNumber: editingItem.altNumber || "",
                clientGroup: editingItem.clientGroup || "",
                latitude: editingItem.latitude || "",
                longitude: editingItem.longitude || "",
                primaryLogistic: editingItem.primaryLogistic || "",
                secondaryLogistic: editingItem.secondaryLogistic || "",
                district: editingItem.district || "",
                area: editingItem.area || "",
                address: editingItem.address || "",
                centre: Number(editingItem.centre) || "",
                password: "", // Keep empty for security
                isActive: editingItem.isActive ?? true,
            });
        } else {
            // Reset form if no editingItem
            setFormData({
                clientName: "",
                clientCode: "",
                panelId: "",
                email: "",
                contactNumber: "",
                altNumber: "",
                clientGroup: "",
                latitude: "22.5726",
                longitude: "88.3639",
                primaryLogistic: "",
                secondaryLogistic: "",
                district: "",
                area: "",
                address: "",
                centre: "",
                password: "",
                isActive: true,
            });
        }
    }, [editingItem]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { showSuccess, showError } = showAlerts;

        // if (formData.primaryLogistic === formData.secondaryLogistic) {
        //     showError("Sorry!", "Primary and Secondary Logistic should not be the same!");
        //     return;
        // }
        try {
            let response;
            if (isEditMode) {
                const payload = { ...formData, id: editingItem.id };
                response = await updateClient(payload); // Call update API
                console.log('update payload', payload)
            } else {
                response = await createClients(formData);

            }

            if (response.status === 1) {
                showSuccess(`Client ${isEditMode ? "updated" : "saved"} successfully!`);
                onSubmitComplete();  // Reset editing state & refresh data
            } else {
                showError("API Error", "Operation failed. Server returned status 0.");
                console.log(response);
            }

        } catch (error) {
            console.error("Error:", error);
            showError("Network Error", `Could not connect to the server. Details: ${error.message}`);
        }
    };


    return (
        <div className="w-full p-4 bg-white rounded-lg shadow-lg h-fit">
            <h3 className="text-xl font-semibold mb-6 text-green-800">New Client Master</h3>
            {/* className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" */}
            <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {/* Client Details */}
                    <input type="text" id="clientName" value={formData.clientName} onChange={handleChange} placeholder="Full name" required className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2" />
                    <input type="text" id="clientCode" value={formData.clientCode} onChange={handleChange} placeholder="Client code" required className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2" />
                    <input type="text" id="panelId" value={formData.panelId} onChange={handleChange} placeholder="Panel ID" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2" />
                    <input type="email" id="email" value={formData.email} onChange={handleChange} placeholder="Email" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2" />
                    <input type="password" id="password" value={formData.password} onChange={handleChange} placeholder="Password" required className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2" />
                    <input type="tel" id="contactNumber" value={formData.contactNumber} onChange={handleChange} placeholder="Mobile No" required className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2" />
                    <input type="tel" id="altNumber" value={formData.altNumber} onChange={handleChange} placeholder="Alternate No" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2" />

                    {/* Client Group */}
                    <select
                        id="clientGroup"
                        value={formData.clientGroup}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    >
                        <option value="" disabled >-client group-</option>
                        {clientGroupOptions.map((item) => (
                            <option key={item.value} value={item.value}>
                                {item.label}
                            </option>
                        ))}
                    </select>

                    {/* <input type="text" id="clientGroup" value={formData.clientGroup} onChange={handleChange} placeholder="Client Group" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2" /> */}

                    {/* <input type="text" id="district" value={formData.district} onChange={handleChange} placeholder="District" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2" /> */}
                    <Select
                        id="district"
                        name="district"
                        required
                        value={districtOptions.find(option => option.value === formData.district) || null}
                        onChange={(selectedOption) => {
                            setFormData(prev => ({
                                ...prev,
                                district: selectedOption ? selectedOption.value : ""
                            }));
                        }}
                        options={districtOptions}
                        placeholder="Select District..."
                        isSearchable
                        className="mt-1"
                        classNamePrefix="react-select"
                        styles={{
                            control: (base) => ({
                                ...base,
                                borderColor: "#d1d5db",
                                borderRadius: "0.375rem",
                                boxShadow: "none",
                                "&:hover": { borderColor: "#16a34a" },
                            }),
                        }}
                    />

                    <input type="text" id="area" value={formData.area} onChange={handleChange} placeholder="Area" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2" />
                    <input type="text" id="address" value={formData.address} onChange={handleChange} placeholder="Address" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2" />


                    <div>
                        {/* <label htmlFor="latitude" className="block text-sm font-medium text-gray-700">Latitude</label> */}
                        <div className="flex space-x-2 mt-1">
                            <input type="text" id="latitude" value={formData.latitude} onChange={handleChange} placeholder="Latitude" className="block w-full border border-gray-300 rounded-md shadow-sm p-2" />
                            <button type="button" onClick={handleOpenMap} className="px-3 py-2 bg-green-500 text-white rounded-md">📍 Select</button>
                        </div>
                    </div>

                    <input type="text" id="longitude" value={formData.longitude} onChange={handleChange} placeholder="Longitude" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2" />
                    {/* centres */}
                    {/* <input type="text" id="centre" value={formData.centre} onChange={handleChange} placeholder="Center" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2" /> */}
                    <div>
                        <label htmlFor="centre" className="block text-sm font-medium text-gray-700">
                            Centre
                        </label>
                        <div className="mt-1">
                            <Select
                                id="centre"
                                name="centre"
                                required
                                value={
                                    formData.centre
                                        ? {
                                            value: formData.centre,
                                            label: centres.find(c => c.id === formData.centre)?.centreName || "",
                                        }
                                        : null
                                }
                                onChange={(selectedOption) =>
                                    setFormData(prev => ({
                                        ...prev,
                                        centre: selectedOption?.value || "",
                                    }))
                                }
                                options={centres.map(c => ({
                                    value: c.id,
                                    label: c.centreName,
                                }))}
                                placeholder="-- Select Centre --"
                                isSearchable
                                className="mt-1"
                                classNamePrefix="react-select"
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        borderColor: "#d1d5db",
                                        borderRadius: "0.375rem",
                                        boxShadow: "none",
                                        "&:hover": { borderColor: "#16a34a" },
                                    }),
                                }}
                            />

                        </div>
                    </div>
                    {/* Logistics and Status */}

                    <div>
                        <label htmlFor="primaryLogistic" className="block text-sm font-medium text-gray-700">
                            Primary Logistic
                        </label>
                        <div className="mt-1">
                            <Select
                                id="primaryLogistic"
                                name="primaryLogistic"
                                required
                                value={
                                    employees
                                        ? employees
                                            .map((employee) => ({
                                                value: employee.id,
                                                label: employee.employeeName,
                                                isDisabled: employee.id === formData.secondaryLogistic,
                                            }))
                                            .find((option) => option.value === formData.primaryLogistic) || null
                                        : null
                                }
                                onChange={(selectedOption) =>
                                    setFormData(prev => ({
                                        ...prev,
                                        primaryLogistic: selectedOption ? selectedOption.value : "",
                                    }))
                                }
                                options={
                                    employees
                                        ? employees.map((employee) => ({
                                            value: employee.id,
                                            label: employee.employeeName,
                                            isDisabled: employee.id === formData.secondaryLogistic,
                                        }))
                                        : []
                                }
                                placeholder="-- Select Primary Logistic --"
                                isSearchable
                                className="mt-1"
                                classNamePrefix="react-select"
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        borderColor: "#d1d5db",
                                        borderRadius: "0.375rem",
                                        boxShadow: "none",
                                        "&:hover": { borderColor: "#16a34a" },
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isDisabled
                                            ? "#f3f4f6"
                                            : state.isSelected
                                                ? "#16a34a"
                                                : state.isFocused
                                                    ? "#dcfce7"
                                                    : "white",
                                        color: state.isDisabled
                                            ? "#9ca3af"
                                            : state.isSelected
                                                ? "white"
                                                : "black",
                                        cursor: state.isDisabled ? "not-allowed" : "pointer",
                                    }),
                                }}
                            />

                        </div>
                    </div>

                    {/* Secondary Logistic Dropdown */}
                    <div>
                        <label htmlFor="secondaryLogistic" className="block text-sm font-medium text-gray-700">
                            Secondary Logistic
                        </label>
                        <div className="mt-1">
                            <Select
                                id="secondaryLogistic"
                                name="secondaryLogistic"
                                value={
                                    employees
                                        ? employees
                                            .map((employee) => ({
                                                value: employee.id,
                                                label: employee.employeeName,
                                                isDisabled: employee.id === formData.primaryLogistic,
                                            }))
                                            .find((option) => option.value === formData.secondaryLogistic) || null
                                        : null
                                }
                                onChange={(selectedOption) =>
                                    setFormData(prev => ({
                                        ...prev,
                                        secondaryLogistic: selectedOption ? selectedOption.value : "",
                                    }))
                                }
                                options={
                                    employees
                                        ? employees.map((employee) => ({
                                            value: employee.id,
                                            label: employee.employeeName,
                                            isDisabled: employee.id === formData.primaryLogistic,
                                        }))
                                        : []
                                }
                                placeholder="-- Select Secondary Logistic --"
                                isSearchable
                                className="mt-1"
                                classNamePrefix="react-select"
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        borderColor: "#d1d5db",
                                        borderRadius: "0.375rem",
                                        boxShadow: "none",
                                        "&:hover": { borderColor: "#16a34a" },
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isDisabled
                                            ? "#f3f4f6"
                                            : state.isSelected
                                                ? "#16a34a"
                                                : state.isFocused
                                                    ? "#dcfce7"
                                                    : "white",
                                        color: state.isDisabled
                                            ? "#9ca3af"
                                            : state.isSelected
                                                ? "white"
                                                : "black",
                                        cursor: state.isDisabled ? "not-allowed" : "pointer",
                                    }),
                                }}
                            />

                        </div>
                    </div>

                    {/* Is Active */}
                    <div className="flex items-center space-x-4 mt-0 md:mt-6">
                        <input type="checkbox" id="isActive" checked={formData.isActive} onChange={handleChange} className="h-4 w-4 text-green-600 border-gray-300 rounded" />
                        <label htmlFor="isActive" className="text-sm font-medium text-gray-700">Is Active</label>
                    </div>
                </div>
                <button type="submit" className="w-full py-2 px-4 mt-3 bg-green-600 text-white rounded-md hover:bg-green-700">
                    {isEditMode ? "Update Client" : "Save Client"}
                </button>
            </form>

            <MapModal
                isOpen={isMapOpen}
                onClose={handleCloseMap}
                initialLat={formData.latitude}
                initialLng={formData.longitude}
                onSaveLatLong={handleSaveLatLong}
            />
        </div>
    );
};


/**
 * COMPLETE Employee Form Component (Full width layout)
 */
const EmployeeForm = ({ editingItem, onSubmitComplete, showAlerts }) => {
    const [centres, setCentreData] = useState([]);

    const [formData, setFormData] = useState({
        employeeName: "",
        employeeCode: "",
        centreName: "",
        phoneNumber: "",
        email: "",
        userType: "",
        deviceId: "",
        status: "1",
        password: "",
    });

    const fetchApiData = useCallback(async () => {
        const centreResponse = await getAllCentre();
        if (centreResponse.status === 1) {
            setCentreData(centreResponse.data)
        } else {
            setCentreData([])
        }
    }, []);

    useEffect(() => {
        fetchApiData();
    }, [fetchApiData]);

    // Handle input changes
    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({ ...prev, [id]: value }));
    };


    const isEditMode = !!editingItem;
    useEffect(() => {
        if (editingItem) {
            setFormData({
                employeeName: editingItem.employeeName || "",
                employeeCode: editingItem.employeeCode || "",
                centreId: editingItem.centreId || "",
                phoneNumber: editingItem.phoneNumber || "",
                email: editingItem.email || "",
                userType: editingItem.userType || "",
                deviceId: editingItem.deviceId || "",
                status: editingItem.status || "1",
                password: "", // optional, blank for editing
            });
        } else {
            // Reset form if no editingItem
            setFormData({
                employeeName: "",
                employeeCode: "",
                centreId: "",
                phoneNumber: "",
                email: "",
                userType: "",
                deviceId: "",
                status: "1",
                password: "",
            });
        }
    }, [editingItem]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        const { showSuccess, showError } = showAlerts;
        try {
            let response;

            if (isEditMode) {
                const payload = { ...formData, id: editingItem.id };
                response = await updateEmployee(payload);
                console.log("Update payload:", payload);
            } else {
                response = await createEmployee(formData);
            }
            console.log("response: ", response)
            if (response.status === 1) {
                showSuccess(`Employee ${isEditMode ? "updated" : "saved"} successfully!`);
                onSubmitComplete(); // Reset editing state & refresh data
                setFormData({
                    employeeName: "",
                    employeeCode: "",
                    centreId: "",
                    phoneNumber: "",
                    email: "",
                    userType: "",
                    deviceId: "",
                    status: "1",
                    password: "",
                });
            } else {
                showError("API Error", "Operation failed. Server returned status 0.");
                console.log(response);
            }
        } catch (error) {
            console.error("Error:", error);
            showError("Network Error", `Could not connect to the server. Details: ${error.message}`);
        }
    };

    return (
        <div className="w-full p-6 bg-white rounded-lg shadow-lg h-fit">
            <h3 className="text-xl font-semibold mb-6 text-green-800">New Employee Master</h3>
            <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {/* Row 1 */}
                <div>
                    <label htmlFor="employeeName" className="block text-sm font-medium text-gray-700">Employee Name</label>
                    <input type="text" id="employeeName" value={formData.employeeName} onChange={handleChange} placeholder="Full name" required className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500" />
                </div>
                <div>
                    <label htmlFor="employeeCode" className="block text-sm font-medium text-gray-700">Employee Code</label>
                    <input type="text" id="employeeCode" value={formData.employeeCode} onChange={handleChange} placeholder="EMP001" required className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500" />
                </div>

                {/* Row 2 */}
                <div>
                    <label htmlFor="phoneNumber" className="block text-sm font-medium text-gray-700">Phone Number</label>
                    <input type="tel" id="phoneNumber" value={formData.phoneNumber} onChange={handleChange} placeholder="e.g. 9000000000" required className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500" />
                </div>
                <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
                    <input type="email" id="email" value={formData.email} onChange={handleChange} placeholder="abc@example.com" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500" />
                </div>

                {/* Row 3 */}
                <div>
                    <label htmlFor="userType" className="block text-sm font-medium text-gray-700">User Type (Mandatory)</label>
                    <select id="userType" value={formData.userType} onChange={handleChange} required className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500">
                        <option value="">-- Select --</option>
                        <option value="OPERATION">OPERATION</option>
                        <option value="LOGISTIC">LOGISTIC</option>
                    </select>
                </div>
                {/* <div>
                    <label htmlFor="centreName" className="block text-sm font-medium text-gray-700">Centre name</label>
                    <input type="text" id="centreName" required value={formData.centreName} onChange={handleChange} placeholder="Name" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500" />
                </div> */}
                <div>
                    <label htmlFor="centre" className="block text-sm font-medium text-gray-700">
                        Centre name
                    </label>
                    <div className="mt-1">
                        <select
                            id="centreId"
                            value={formData.centreId}
                            onChange={handleChange}
                            className="block w-full py-2 px-3 border border-gray-300 bg-white rounded-lg shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm transition duration-150 ease-in-out"
                        >
                            {/* Default option */}
                            <option value="" disabled>-- Select --</option>

                            {/* Map over the employees data to create options */}
                            {centres.map((centre) => (
                                <option
                                    key={centre.id}
                                    value={centre.id}
                                    // Disable the option if it is already selected as the secondary logistic
                                    disabled={centre.id === formData.centre}
                                >
                                    {centre.centreName}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                {/* Row 4 */}
                <div>
                    <label htmlFor="deviceId" className="block text-sm font-medium text-gray-700">Device ID (Optional)</label>
                    <input type="text" id="deviceId" value={formData.deviceId} onChange={handleChange} placeholder="DEVICE12345" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500" />
                </div>
                <div>
                    <label htmlFor="status" className="block text-sm font-medium text-gray-700">Status (Optional)</label>
                    <select id="status" value={formData.status} onChange={handleChange} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500">
                        <option value="1">ACTIVE</option>
                        <option value="0">INACTIVE</option>
                    </select>
                </div>

                {/* Password (Full Width) */}
                <div className="col-span-full lg:col-span-1">
                    <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
                    <input type="password" id="password" value={formData.password} onChange={handleChange} placeholder="abc@123" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500" />
                </div>

                {/* Submit */}
                <div className="col-span-full mt-4">
                    <button type="submit" className="w-full py-2 px-4 bg-green-600 text-white rounded-md hover:bg-green-700">
                        {isEditMode ? "Update Employee" : "Save Employee"}
                    </button>
                </div>
            </form>
        </div>
    );
};


/**
 * COMPLETE Centre Form Component (Full width layout and Map Integration)
 */
const CentreForm = ({ editingItem = null, onSubmitComplete, showAlerts }) => {
    const [isMapOpen, setIsMapOpen] = useState(false);

    const [formData, setFormData] = useState({
        centreName: "",
        centreCode: "",
        region: "",
        state: "",
        district: "",
        contactNumber: "",
        address: "",
        latitude: "22.5726",
        longitude: "88.3639",
        status: "1",
    });

    // ✅ Open/Close modal
    const handleOpenMap = () => setIsMapOpen(true);
    const handleCloseMap = () => setIsMapOpen(false);

    // ✅ Save lat/lng from MapModal
    const handleSaveLatLong = (lat, lng) => {
        setFormData((prev) => ({
            ...prev,
            latitude: lat,
            longitude: lng,
        }));
        console.log("📍 Selected Coordinates:", lat, lng);
        setIsMapOpen(false); // optional: close modal after selecting
    };

    // ✅ Generic change handler
    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: value,
        }));
    };

    const isEditMode = !!editingItem;

    // Pre-fill form when editingItem changes
    useEffect(() => {
        if (editingItem) {
            setFormData({
                centreName: editingItem.centreName || "",
                centreCode: editingItem.centreCode || "",
                region: editingItem.region || "",
                state: editingItem.state || "",
                district: editingItem.district || "",
                contactNumber: editingItem.contactNumber || "",
                address: editingItem.address || "",
                latitude: editingItem.latitude || "22.5726",
                longitude: editingItem.longitude || "88.3639",
                status: editingItem.status || "1",
            });
        } else {
            setFormData({
                centreName: "",
                centreCode: "",
                region: "",
                state: "",
                district: "",
                contactNumber: "",
                address: "",
                latitude: "22.5726",
                longitude: "88.3639",
                status: "1",
            });
        }
    }, [editingItem]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("📩 Centre Payload:", formData);
        const { showSuccess, showError } = showAlerts;
        try {
            let response;
            if (isEditMode) {
                const payload = { ...formData, id: editingItem.id };
                response = await updateCenter(payload);
            } else {
                response = await createCenter(formData);
            }

            if (response.status === 1) {
                showSuccess(`Centre ${isEditMode ? "updated" : "saved"} successfully!`);
                // alert(`Centre ${isEditMode ? "updated" : "saved"} successfully!`);
                if (onSubmitComplete) onSubmitComplete();
            } else {
                // alert("Failed! Check console.");
                showError("API Error", "Operation failed. Server returned status 0.");
                console.log(response);
            }
        } catch (error) {
            console.error("Error:", error);
            showError("Network Error", `Could not connect to the server. Details: ${error.message}`);
        }
    };

    // ✅ Form submit
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     console.log("📝 Submitted Form Data:", formData);
    //     const response = await createCenter(formData);
    //     if (response.status == 1) {
    //         alert(`Form Submitted!`);
    //     } else {
    //         alert(`Form Submitted failed!`);

    //     }

    // };

    return (
        <div className="w-full p-6 bg-white rounded-lg shadow-lg h-fit">
            <h3 className="text-xl font-semibold mb-6 text-green-800">
                Centre Master
            </h3>

            <form
                onSubmit={handleSubmit}
                className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
            >
                {/* Row 1 */}
                <div>
                    <label htmlFor="centreName" className="block text-sm font-medium text-gray-700">
                        Centre Name
                    </label>
                    <input
                        type="text"
                        id="centreName"
                        value={formData.centreName}
                        onChange={handleChange}
                        placeholder="Enter Center Name"
                        required
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500"
                    />
                </div>

                <div>
                    <label htmlFor="centreCode" className="block text-sm font-medium text-gray-700">
                        Centre Code
                    </label>
                    <input
                        type="text"
                        id="centreCode"
                        value={formData.centreCode}
                        onChange={handleChange}
                        placeholder="CTR001"
                        required
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500"
                    />
                </div>

                {/* Row 2 */}
                <div>
                    <label htmlFor="region" className="block text-sm font-medium text-gray-700">
                        Region
                    </label>
                    <input
                        type="text"
                        id="region"
                        value={formData.region}
                        onChange={handleChange}
                        placeholder="Enter Region"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500"
                    />
                </div>

                <div>
                    <label htmlFor="state" className="block text-sm font-medium text-gray-700">
                        State
                    </label>
                    <input
                        type="text"
                        id="state"
                        value={formData.state}
                        onChange={handleChange}
                        placeholder="Enter State"
                        required
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500"
                    />
                </div>

                {/* Row 3 */}
                <div>
                    <label htmlFor="district" className="block text-sm font-medium text-gray-700">
                        District
                    </label>
                    <input
                        type="text"
                        id="district"
                        value={formData.district}
                        onChange={handleChange}
                        placeholder="Enter District"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500"
                    />
                </div>

                <div>
                    <label htmlFor="contactNumber" className="block text-sm font-medium text-gray-700">
                        Contact Number
                    </label>
                    <input
                        type="tel"
                        id="contactNumber"
                        value={formData.contactNumber}
                        onChange={handleChange}
                        placeholder="e.g. 9000000000"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500"
                    />
                </div>

                {/* Row 4 (Full Width Address) */}
                <div className="col-span-full">
                    <label htmlFor="address" className="block text-sm font-medium text-gray-700">
                        Address
                    </label>
                    <input
                        type="text"
                        id="address"
                        value={formData.address}
                        onChange={handleChange}
                        placeholder="Enter Address"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500"
                    />
                </div>

                {/* Row 5 - Latitude with Map Button */}
                <div>
                    <label htmlFor="latitude" className="block text-sm font-medium text-gray-700">
                        Latitude
                    </label>
                    <div className="flex space-x-2 mt-1">
                        <input
                            type="text"
                            id="latitude"
                            value={formData.latitude}
                            onChange={handleChange}
                            placeholder="Enter Latitude"
                            className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500"
                        />
                        <button
                            type="button"
                            onClick={handleOpenMap}
                            className="whitespace-nowrap px-3 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-500 hover:bg-green-600"
                            title="Select on Map"
                        >
                            <span className="md:hidden">Map</span>
                            <span className="hidden md:inline">📍 Select</span>
                        </button>
                    </div>
                </div>

                {/* Longitude Field */}
                <div>
                    <label htmlFor="longitude" className="block text-sm font-medium text-gray-700">
                        Longitude
                    </label>
                    <input
                        type="text"
                        id="longitude"
                        value={formData.longitude}
                        onChange={handleChange}
                        placeholder="Enter Longitude"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500"
                    />
                </div>

                {/* Status */}
                <div className="col-span-full lg:col-span-1">
                    <label htmlFor="status" className="block text-sm font-medium text-gray-700">
                        Status
                    </label>
                    <select
                        id="status"
                        value={formData.status}
                        onChange={handleChange}
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-green-500 focus:border-green-500"
                    >
                        <option value="1">ACTIVE</option>
                        <option value="0">INACTIVE</option>
                    </select>
                </div>

                {/* Submit */}
                <div className="col-span-full mt-4">
                    <button
                        type="submit"
                        className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition duration-150"
                    >
                        {isEditMode ? "Update Centre" : "Save Centre"}
                    </button>
                </div>
            </form>

            {/* Map Modal */}
            <MapModal
                isOpen={isMapOpen}
                onClose={handleCloseMap}
                initialLat={formData.latitude}
                initialLng={formData.longitude}
                onSaveLatLong={handleSaveLatLong}
            />
        </div>
    );
};


// --- Main Application Component (Fixed all layouts) ---

const MasterPage = () => {
    const [activeTab, setActiveTab] = useState('client');
    const [clientData, setClientData] = useState([]);
    const [employees, setEmployeeData] = useState([]);
    const [centres, setCentreData] = useState([]);
    const [editingItem, setEditingItem] = useState(null);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalConfig, setModalConfig] = useState({});


    const showSuccess = (msg) => {
        setModalConfig({
            title: "Success!",
            message: msg,
            type: "success",
        });
        setIsModalOpen(true);
    };

    const showError = (titleMsg, message) => {
        setModalConfig({
            title: titleMsg,
            message: message,
            type: "error",
        });
        setIsModalOpen(true);
    };


    const fetchApiData = useCallback(async () => {
        const response = await getAllClients();
        if (response.status === 1) {
            setClientData(response.data)
        } else {
            setClientData([])
        }

        const empResponse = await getAllEmployees();
        if (empResponse.status === 1) {
            setEmployeeData(empResponse.data)
        } else {
            setEmployeeData([])
        }

        const centreResponse = await getAllCentre();
        if (centreResponse.status === 1) {
            setCentreData(centreResponse.data)
        } else {
            setCentreData([])
        }
    }, []);

    useEffect(() => {
        fetchApiData();
    }, [fetchApiData]);


    const handleEdit = (item, type) => {
        setEditingItem(item); // This tells the form which item to edit
        setActiveTab(type);   // Switch to the correct tab automatically

         window.scrollTo({ top: 0, behavior: "smooth" });
    };


    const handleDelete = (item) => {
        alert("Work in progress!")
        console.log("Deleting item:", item);
        // TODO: Implement confirmation and API call to delete the item
    };
    const renderContent = () => {
        const layoutClass = "flex flex-col gap-6";

        switch (activeTab) {
            case 'client':
                return (
                    <div className={layoutClass}>
                        <ClientForm
                            editingItem={editingItem}
                            setEditingItem={setEditingItem}
                            showAlerts={{ showSuccess, showError }}
                            onSubmitComplete={() => {
                                setEditingItem(null); // Reset edit mode
                                fetchApiData();       // Refresh the list
                            }}
                        />
                        <DataList data={clientData} entityType="client"
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                    </div>
                );
            case 'employee':
                return (
                    <div className={layoutClass}>
                        <EmployeeForm
                            editingItem={editingItem && activeTab === 'employee' ? editingItem : null}
                            showAlerts={{ showSuccess, showError }}
                            onSubmitComplete={() => {
                                setEditingItem(null);
                                fetchApiData();
                            }}
                        />
                        <DataList data={employees} entityType="employee"
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                    </div>
                );
            case 'centre':
                return (
                    <div className={layoutClass}>
                        <CentreForm editingItem={editingItem && activeTab === 'centre' ? editingItem : null}
                            showAlerts={{ showSuccess, showError }}
                            onSubmitComplete={() => {
                                setEditingItem(null);
                                fetchApiData();
                            }} />
                        <DataList data={centres} entityType="centre"
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                    </div>
                );
            default:
                return null;
        }
    };

    const TabButton = ({ name, label }) => (
        <button
            className={`
                py-3 px-3 md:px-3 text-sm font-semibold transition duration-200
                ${activeTab === name
                    ? 'border-b-4 border-green-600 text-green-700 bg-green-50'
                    : 'border-b-4 border-transparent text-gray-600 hover:text-green-600 hover:bg-gray-100'
                }
            `}
            onClick={() => setActiveTab(name)}
        >
            {label}
        </button>
    );

    return (
        <div className="bg-gray-50 min-h-screen">
            <div className="main-wrap">
                <div className="container">
                    <div className="title">
                        <h4>
                            Master Data Management - <span className="text-green-600">Operations</span>
                        </h4>
                    </div>

                    {/* Tabs Container */}
                    <div className="flex border-b border-gray-200 mb-6 overflow-x-auto">
                        <TabButton name="client" label="Client Master" />
                        <TabButton name="employee" label="Employee Master" />
                        <TabButton name="centre" label="Centre Master" />
                    </div>

                    {/* Content Area */}
                    <div className="bg-white p-4 sm:p-6 rounded-xl shadow-2xl">
                        {renderContent()}
                    </div>
                </div>
            </div>

            <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                title={modalConfig.title}
                message={modalConfig.message}
                type={modalConfig.type}
            />
        </div>
    );
};

export default MasterPage;